export default __webpack_public_path__ + "static/media/frechen_dark.6b323490.png";